import Navigation from '@components/main/navigation';
import ReviewPopup from '@components/reviewPopup';
import { ReactNode } from 'react';

interface LayoutProps {
	children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
	return (
		<div className='h-screen flex flex-col'>
			<div className='w-full flex-none justify-center'>
				<Navigation />
			</div>
			<div className='h-full flex-grow overflow-y-auto'>{children}</div>
			<ReviewPopup />
		</div>
	);
};

export default Layout;
